import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import TContainer from './ToastContainer';
import ToastMessage from './ToastMessage';

export const ToastContainer = TContainer;

export const toastColors = {
  SUCCESS: '#008636',
  ERROR: '#e32942',
  INFO: '#0074cc',
  OFFLINE: '#4d555c',
} as const;

// The Toast lib doesn't seem to have a type for this.
type ToastFuncParams = {
  closeToast: () => void;
};

const toastOptions = {
  className: 'toast',
  bodyClassName: 'toast-body',
  closeButton: false,
};

export const info = (content: React.ReactNode, heading = 'Update'): void => {
  toast(
    ({ closeToast }: ToastFuncParams) => (
      <ToastMessage
        heading={heading}
        closeToast={closeToast}
        backgroundColor={toastColors.INFO}
      >
        {content}
      </ToastMessage>
    ),
    toastOptions
  );
};

export const success = (
  content: React.ReactNode,
  heading = 'Success'
): void => {
  toast(
    ({ closeToast }: ToastFuncParams) => (
      <ToastMessage
        heading={heading}
        closeToast={closeToast}
        backgroundColor={toastColors.SUCCESS}
      >
        {content}
      </ToastMessage>
    ),
    toastOptions
  );
};

export const error = (content: React.ReactNode, heading = 'Uh-oh!'): void => {
  toast(
    ({ closeToast }: ToastFuncParams) => (
      <ToastMessage
        heading={heading}
        closeToast={closeToast}
        backgroundColor={toastColors.ERROR}
      >
        {content}
      </ToastMessage>
    ),
    toastOptions
  );
};

interface OfflineToastText {
  offline: {
    title: string;
    message: string;
  };
}

export const offline = (toastText: OfflineToastText): void => {
  toast(
    ({ closeToast }: ToastFuncParams) => (
      <ToastMessage
        heading={toastText.offline.title}
        closeToast={closeToast}
        backgroundColor={toastColors.OFFLINE}
      >
        {toastText.offline.message}
      </ToastMessage>
    ),
    toastOptions
  );
};

export default { info, success, error, offline };
